import { Link } from 'react-router-dom';

interface CategoryCardProps {
  slug: string;
  name: string;
  description: string;
  icon: string;
  color: string;
  count: number;
}

export default function CategoryCard({ slug, name, description, icon, color, count }: CategoryCardProps) {
  const colorMap: Record<string, { bg: string; text: string; iconBg: string }> = {
    primary: { bg: 'hover:border-primary-300', text: 'text-primary-700', iconBg: 'bg-primary-100' },
    accent: { bg: 'hover:border-accent-300', text: 'text-accent-700', iconBg: 'bg-accent-100' },
    secondary: { bg: 'hover:border-secondary-300', text: 'text-secondary-700', iconBg: 'bg-secondary-100' },
  };

  const c = colorMap[color] || colorMap.primary;

  return (
    <Link
      to={`/category/${slug}`}
      className={`bg-background-50 rounded-xl border border-background-200 p-5 transition-all duration-300 ${c.bg} group cursor-pointer block`}
    >
      <div className={`w-10 h-10 flex items-center justify-center rounded-lg ${c.iconBg} mb-3`}>
        <i className={`${icon} text-lg ${c.text}`}></i>
      </div>
      <h3 className="font-heading font-semibold text-foreground-900 text-sm mb-1.5">
        {name}
      </h3>
      <p className="text-xs text-foreground-500 leading-relaxed mb-3">
        {description}
      </p>
      <span className="text-[11px] text-foreground-400">
        {count} 篇文章
      </span>
    </Link>
  );
}